import { ClientContext } from "#/context/ClientContext";
import { useContext } from "react";

export const useClient = () => {
  const ctx = useContext(ClientContext);
  if (!ctx) throw new Error("useClient must be used inside ClientProvider");
  return ctx;
};
